import { render, staticRenderFns } from "./AlignGroup.vue?vue&type=template&id=6d2993ca&scoped=true&"
import script from "./AlignGroup.vue?vue&type=script&lang=js&"
export * from "./AlignGroup.vue?vue&type=script&lang=js&"
import style0 from "./AlignGroup.vue?vue&type=style&index=0&id=6d2993ca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2993ca",
  null
  
)

export default component.exports